import EntityDetailsProvider from '@shared/components/details/entity-details-provider/entity-details-provider.vue';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import InvoiceDetailsPresentational from '../invoice-details-presentational/invoice-details-presentational.vue';
import HtmlToPdf from '@shared/components/html-to-pdf/html-to-pdf.vue';
import { InvoiceDetail } from '@accounting/interfaces/invoice';
@Component({
  name: 'bpc-invoice-details',
  components: {
    'bpc-entity-details-provider': EntityDetailsProvider,
    'bpc-invoice-details-presentational': InvoiceDetailsPresentational,
    'bpc-html-to-pdf': HtmlToPdf,
  },
})
export default class InvoiceDetails extends Vue {
  $refs: {
    htmlToPdf: InstanceType<typeof HtmlToPdf> & {
      printContent(): Promise<void>;
    };
  };
  @Prop(String) readonly entity: string;
  @Prop(Number) readonly entityId: number;
  @Prop(Boolean) readonly autoDownload: boolean;
  @Prop(String) readonly invoiceCode: string;
  @Prop({ type: Boolean, default: false }) readonly hideDownloadButton: boolean;
  @Prop({ type: Boolean, default: false }) readonly hideLayoutSelector: boolean;
  @Prop({ type: Boolean, default: false }) readonly useTokenToDownload: boolean;
  @Prop({ type: String }) readonly invoiceToken: string;

  printing: boolean = false;
  documentName: string = 'download.pdf';
  selectedLayout: string = 'full_details';
  get layoutOptions() {
    return [
      {
        value: 'full_details',
        text: this.$t('global.default_invoice_layout_full_details'),
      },
      {
        value: 'summary',
        text: this.$t('global.default_invoice_layout_summary'),
      },
      {
        value: 'summary_and_details',
        text: this.$t('global.default_invoice_layout_summary_and_details'),
      },
    ];
  }
  get tenantId(): number {
    return this.$store.getters['tenant/selectedTenantId'];
  }

  onLoadItem(event: InvoiceDetail) {
    this.documentName = `${this.$t('global.invoice.label')}-${this.getInvoiceCodeString(
      event,
    )}.pdf`;
    this.selectedLayout = event.invoice_layout;
    this.maybeDownload();
  }
  maybeDownload() {
    if (this.autoDownload) {
      this.printInvoice();
    }
  }

  onGeneratedPDF($event) {
    this.printing = false;
    this.$emit('generated-invoice', $event);
  }

  onDownload() {
    const url = this.$bpcApiRouteHelper.getEntityPath('invoices');
    if (this.useTokenToDownload) {
      this.$bpcApi
        .postDownload(`${url}/generate-pdf-by-token/${this.invoiceToken}`, '', {
          template: this.selectedLayout,
        })
        .subscribe(res => {
          console.log(res);
        });
    } else {
      this.$bpcApi
        .postDownload(`${url}/generate-pdf/`, '', {
          invoice_ids: [this.entityId],
          template: this.selectedLayout,
          tenant_id: this.tenantId,
        })
        .subscribe(res => {
          console.log(res);
        });
    }
  }

  getInvoiceCodeString(invoice: InvoiceDetail): string {
    return invoice.document_number ? invoice.document_number : this.invoiceCode;
  }

  async printInvoice() {
    this.documentName = `${this.$t('global.invoice.label')}-${this.invoiceCode}.pdf`;
    this.printing = true;
  }

  async forcePrintInvoice() {
    this.documentName = `${this.$t('global.invoice.label')}-${this.invoiceCode}.pdf`;
    this.printing = true;
    this.$refs.htmlToPdf.printContent();
  }
}
